import { render, staticRenderFns } from "./AdministracionDeProspectos.vue?vue&type=template&id=55e6ca0f&scoped=true&"
import script from "./AdministracionDeProspectos.vue?vue&type=script&lang=js&"
export * from "./AdministracionDeProspectos.vue?vue&type=script&lang=js&"
import style0 from "./AdministracionDeProspectos.vue?vue&type=style&index=0&id=55e6ca0f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e6ca0f",
  null
  
)

export default component.exports